import { REMEDIATION_CONSTANTS } from '../components/NRRemediation/NRRemediation.constants';
import { CONSTANTS } from '../constants/constants';
import FiberManualRecordOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const { LOW, MEDIUM, HIGH, CRITICAL } = CONSTANTS.SEVERITIES;
const { MINOR, MAJOR, BLOCKER } = CONSTANTS.LICENSE_ISSUES_SEVERITIES;
const { FALSE_POSITIVE, RESOLVED_WITH_PEDIGREE, UNSPECIFIED, NOT_AFFECTED, AFFECTED, FIXED, UNDER_INVESTIGATION, UNREVIEWED, RESOLVED, IN_REVIEW } =
  REMEDIATION_CONSTANTS.STATUS.VALUES;

export default function hexToRgbA(hex, alpha) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `,${alpha})`;
  }
  throw new Error('Bad Hex');
}

export const getSeverityColor = (text, theme) => {
  switch (text?.toLowerCase()) {
    case LOW.toLowerCase():
      return theme.palette.weightedColors[2][500];
    case MEDIUM.toLowerCase():
    case MINOR.toLowerCase():
      return theme.palette.weightedColors[3][300];
    case HIGH.toLowerCase():
    case MAJOR.toLowerCase():
      return theme.palette.weightedColors[4][300];
    case CRITICAL.toLowerCase():
    case BLOCKER.toLowerCase():
      return theme.palette.weightedColors[5][600];
    default:
      return theme.palette.neutral[200];
  }
};

export function getRemediationIconTextAndColor(text, theme) {
  switch (text) {
    case UNSPECIFIED:
    case UNREVIEWED:
      return [FiberManualRecordOutlinedIcon, REMEDIATION_CONSTANTS.STATUS.LABELS[text], theme.palette.statusPalette[2], theme.palette.text.secondary];
    case NOT_AFFECTED:
    case FIXED:
    case FALSE_POSITIVE:
    case RESOLVED:
      return [FiberManualRecordIcon, REMEDIATION_CONSTANTS.STATUS.LABELS[text], theme.palette.success.main, theme.palette.success.dark];
    case RESOLVED_WITH_PEDIGREE:
      return [FiberManualRecordIcon, REMEDIATION_CONSTANTS.STATUS.LABELS[text], theme.palette.success.main, theme.palette.success.dark];
    case AFFECTED:
      return [FiberManualRecordIcon, REMEDIATION_CONSTANTS.STATUS.LABELS[text], theme.palette.error.main, theme.palette.error.dark];
    case UNDER_INVESTIGATION:
    case IN_REVIEW:
      return [FiberManualRecordIcon, REMEDIATION_CONSTANTS.STATUS.LABELS[text], theme.palette.info.main, theme.palette.info.dark];
    default:
      return [
        FiberManualRecordOutlinedIcon,
        REMEDIATION_CONSTANTS.STATUS.LABELS.UNSPECIFIED,
        theme.palette.statusPalette[2],
        theme.palette.text.secondary
      ];
  }
}
